import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import './Product.css';

// import required modules
import { Navigation } from 'swiper/modules';

const Product = () => {
  const cardStyle = {
    width: '100%',
    height: 'auto', // Set a fixed height\
    minheight: '400px',
    alignItems: 'center',
    padding: '1rem',
    gap: '2rem',
    boxShadow: '0 0 1px white',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between', // This will distribute space evenly
  };

  // const cardStyle = {
  //   width: '100%',
  //   //height: '400px',
  //   alignItems: 'center',
  //   padding: '1rem',
  //   gap: '2rem',
  //   boxShadow: '0 0 1px white',
  //   borderRadius: '8px',
  // };

  // Card content template for reuse with dynamic content
  const CardContent = ({ videoUrl, quote, authorName, authorRole }) => (
    <div style={cardStyle}>
      {/* <div style={{ position: 'relative', width: '100%', height: '250px' }}> */}
      <iframe
        title={authorName}
        src={videoUrl}
        loading='lazy'
        style={{
          border: '0',
          // position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '60%',
          borderRadius: '1rem',
        }}
        allow='accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;'
        allowFullScreen
      />
      {/* </div> */}
      <div style={{ textAlign: 'left', padding: '1rem 0', width: '100%' }}>
        <p
          style={{
            color: '#999',
            fontStyle: 'italic',
            width: '100%',
            textAlign: 'left',
            fontSize: '16px',
            fontWeight: '500',
            margin: '0',
          }}
        >
          {quote}
        </p>
      </div>
      <div
        style={{
          color: '#999',
          fontStyle: 'italic',
          width: '100%',
          textAlign: 'left',
          fontSize: '16px',
          fontWeight: '500',
          margin: '0',
        }}
      >
        <p style={{ fontWeight: '500', margin: '0.25rem 0' }}>{authorName}</p>
        <p style={{ fontSize: '12px', color: '#999', margin: '0' }}>{authorRole}</p>
      </div>
    </div>
  );

  // Array of objects for dynamic video and text content
  const contentData = [
    {
      videoUrl: 'https://www.youtube.com/embed/yNMlbigQlTI',
      quote:
        '“Sru is amazing, and super organised, and it helps move everything along in the right direction. From our Socials, blogs, and Weekly Newsletters to getting the lunch done.!”',
      authorName: 'Malik Shkraba',
      authorRole: 'COO of Friday',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/4jWJY8Pq8yU',
      quote:
        "'“She's come in and optimize and systematize the entire process of social media. I have my scripts every single week. All I have to do is show up and do what I do best, which is deliver a message.”'",
      authorName: 'Author 1',
      authorRole: 'Content Creator',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/e4zj8uo-wRY',
      quote:
        "'“She's creative, the most creative person I have ever met, I would say. She will treat your business as her business. That's the kind of experience I got working with her.”'",
      authorName: 'Author 2',
      authorRole: 'Adventurer',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/9Dyj1cZrtBE',
      quote:
        '“They have been able to take out all the stress of getting out content online.”',
      authorName: 'Author 3',
      authorRole: 'Innovator',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/v1-Use9o7Ic',
      quote:
        "'“She is communicative and responsive and keeps her commitment to me. And more often, she's ahead of me.”'",
      authorName: 'Author 4',
      authorRole: 'Storyteller',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/eK6i9iV94Ig',
      quote:
        '“She helped me to plan out my marketing in a way that was clear and concise so that I could grab those potential clients.”',
      authorName: 'Author 5',
      authorRole: 'Technologist',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/Y0hC6vRbImI',
      quote:
        '“Saryu has really been an integral part of the success in one of my new programs launching. She guided me through the entire beta launch.”',
      authorName: 'Author 6',
      authorRole: 'Motivational Speaker',
    },
    //new adding
    {
      videoUrl: 'https://www.youtube.com/embed/IlpGcdeJY44',
      quote:
        '“What I love about working with Sru is her systematic approach.  She takes the time to understand your audience and delivers strategies that connect and convert. She also helps build a strong social presence that feels effortless and speaks directly to your audience.”',
      authorName: 'Author 7',
      authorRole: 'Motivational Speaker',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/3ctnI6k2Wcs',
      quote:
        '“Before Sru, my social media was a hot mess, disorganised and overwhelming. She streamlined everything, organised my systems, and made content creation feel easy and stress-free”',
      authorName: 'Author 8',
      authorRole: 'Motivational Speaker',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/jKm-STUunD8',
      quote:
        '“Sru, doesn’t just put work into your business, she puts in her heart and mind. She planned my 5-day challenge with such detail and strategy that nothing was missed, and everything ran smoothly.”',
      authorName: 'Author 9',
      authorRole: 'Motivational Speaker',
    },
    {
      videoUrl: 'https://www.youtube.com/embed/cqyDI4DKQJ4',
      quote:
        '“Sru, took control of our email campaigns, improved deliverability, and built an evergreen sequence that converts. We closed a deal right after going live, and the results were instant”',
      authorName: 'Author 10',
      authorRole: 'Motivational Speaker',
    },
  ];

  return (
    <div
      className='reviews-container'
    >
      <Swiper
        navigation={true}
        modules={[Navigation]}
        className='mySwiper'
        slidesPerView={3}
        spaceBetween={50}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
      >
        {contentData.map((content, index) => (
          <SwiperSlide key={index} style={{}}>
            <CardContent
              videoUrl={content.videoUrl}
              quote={content.quote}
            // authorName={content.authorName}
            // authorRole={content.authorRole}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Product;
